export async function requestStorySummary({
  events,
  endpoint,
  toLLMEvent,
  validateStoryDraft,
  buildStoryLikeFallback,
  fetchRef = fetch,
}) {
  if (!endpoint) {
    return buildStoryLikeFallback(events)
  }
  const response = await fetchRef(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      task: 'summarize-selection',
      promptVersion: 'selection-summary-v1',
      events: events.map(toLLMEvent),
    }),
  })
  if (!response.ok) {
    throw new Error(`LLM endpoint returned ${response.status}`)
  }
  const draft = await response.json()
  return validateStoryDraft(draft, events)
}
